// 先吸附顶点，再吸附最近边线；保留共享边的原精度，避免屏幕点击取整造成细小空洞。
export function snapToMapEdges (x,y,rings,radius) {
  let nearest=radius,result=null
  for(const ring of rings)for(const point of ring){
    const px=Number(point[0]),py=Number(point[1]),distance=Math.hypot(px-x,py-y)
    if(distance<nearest){nearest=distance;result=[px,py]}
  }
  if(result)return result
  for(const ring of rings)for(let i=0;i<ring.length;i++){
    const a=ring[i],b=ring[(i+1)%ring.length],ax=Number(a[0]),ay=Number(a[1]),dx=Number(b[0])-ax,dy=Number(b[1])-ay,length=dx*dx+dy*dy
    if(!length)continue
    const t=Math.max(0,Math.min(1,((x-ax)*dx+(y-ay)*dy)/length)),px=ax+t*dx,py=ay+t*dy,distance=Math.hypot(px-x,py-y)
    if(distance<nearest){nearest=distance;result=[px,py]}
  }
  return result||[x,y]
}
